import { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { getAppleTransactionLogs } from "../../../services"; // Adjust the import path as needed
import { DataTableSearchHeader } from "../common";
import { Badge } from "primereact/badge";

const AppleTransactionsDataTable = () => {
  const [transactions, setTransactions] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });
  const [totalElements, setTotalElements] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(null);

  useEffect(() => {
    console.log("AppleTransactionsDataTable")
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const data = await getAppleTransactionLogs(pagination.page, pagination.size);
        console.log("data:", data)
        setTransactions(data.content);
        setTotalElements(data.totalElements);
        setPageCount(data.totalPages);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [pagination.page, pagination.size]);

  const handlePageChange = (event: any) => {
    setPagination({ page: event.page, size: event.rows });
  };

  const statusBodyTemplate = (rowData: any) => {
    return (
      <Badge
        value={rowData.status  === "CONFIRMED_BY_NOTIFICATION" ? "Confirmed" : "Not Confirmed"}
        severity={rowData.status === "CONFIRMED_BY_NOTIFICATION" ? "success" : "warning"}
      />
    );
  };

  return (
    <>
      <DataTable
        value={transactions}
        paginator
        rows={pagination.size}
        first={pagination.page * pagination.size}
        lazy
        onPage={handlePageChange}
        dataKey="id"
        loading={loading}
        totalRecords={totalElements}
        pageLinkSize={5}
        emptyMessage="No Log found."
        rowsPerPageOptions={[5, 10, 25, 50]}
        header={
          <DataTableSearchHeader
            title={"Transaction List"}
            filters={filters}
            onChange={(e: any) => setFilters(e)}
          />
        }
      >
        <Column
          field="id"
          header={"ID"}
          sortable
          style={{ minWidth: "4rem", cursor: "pointer" }}
        />
       
        <Column
          field="customerEmail"
          header={"Email"}
          sortable
          style={{ minWidth: "10rem" }}
        />
        <Column
          field="transactionId"
          header={"Transaction ID"}
          sortable
          style={{ minWidth: "10rem" }}
        />
        <Column
          field="purchaseDate"
          header={"Purchase Date"}
          sortable
          style={{ minWidth: "10rem" }}
          body={(rowData) =>
            rowData.purchaseDate && (
              <>{moment(rowData.purchaseDate).format("DD/MM/YYYY, hh:mm a")}</>
            )
          }
        />
        <Column
          field="status"
          header={"Status"}
          sortable
          style={{ minWidth: "5rem" }}
          body={statusBodyTemplate}
        />
      </DataTable>
    </>
  );
};

export default AppleTransactionsDataTable;
